module.exports = __webpack_public_path__ + "static/media/1f451.06b2dc52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f451.svg
// module id = 261
// module chunks = 1